import { ACTION, isMultileg, isOption, type Security } from '@talos/kyoko';
import { useMemo } from 'react';
import { useRoleAuth } from '../../hooks';

/** Houses some re-used logic needed in different parts of the Market Data Card */
export const useMarketDataCard = (
  security?: Security
): {
  canViewOrder: boolean;
  canSubmitOrder: boolean;
  canRequestRFQ: boolean;
  canViewCandleStickChart: boolean;
} => {
  const { isAuthorized } = useRoleAuth();
  const canViewOrder = useMemo(() => isAuthorized(ACTION.VIEW_ORDER), [isAuthorized]);
  const canSubmitOrder = useMemo(() => isAuthorized(ACTION.SUBMIT_ORDER), [isAuthorized]);
  const canRequestRFQ = useMemo(() => isAuthorized(ACTION.REQUEST_RFQ), [isAuthorized]);
  const canViewCandleStickChart = useMemo(() => !(isMultileg(security) || isOption(security)), [security]);

  return {
    canViewOrder,
    canSubmitOrder,
    canRequestRFQ,
    canViewCandleStickChart,
  };
};
